/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
  name: "ShellPreview",
  components: {
    customModal,
  },
  emits: ["closeModal"],
  props: {
    editingId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      loading: false,
      shell: null,
      tokenOptions: [],
      selectoption: "figure",



      // Table summary row
      tableSummary: { label: 'Number of Subjects with any TEAE', placebo: '22(73.33%)', bmsLow: '25(83.33%)', bmsHigh: '27(90.00%)', total: '74(82.22%)' },

      // Table data sections
      tableData: [
        {
          section: 'Gastrointestinal Disorders',
          rows: [
            { term: 'Nausea', placebo: '3(10.00%)', bmsLow: '4(13.33%)', bmsHigh: '7(23.33%)', total: '14(15.56%)' },
            { term: 'Vomiting', placebo: '2(6.67%)', bmsLow: '3(10.00%)', bmsHigh: '5(16.67%)', total: '10(11.11%)' },
            { term: 'Diarrhoea', placebo: '4(13.33%)', bmsLow: '5(16.67%)', bmsHigh: '6(20.00%)', total: '15(16.67%)' },
            { term: 'Abdominal Pain', placebo: '2(6.67%)', bmsLow: '2(6.67%)', bmsHigh: '3(10.00%)', total: '7(7.78%)' },
            { term: 'Constipation', placebo: '1(3.33%)', bmsLow: '2(6.67%)', bmsHigh: '2(6.67%)', total: '5(5.56%)' },
            { term: 'Dyspepsia', placebo: '1(3.33%)', bmsLow: '1(3.33%)', bmsHigh: '3(10.00%)', total: '5(5.56%)' }
          ]
        },
        {
          section: 'Nervous System Disorders',
          rows: [
            { term: 'Headache', placebo: '5(16.67%)', bmsLow: '6(20.00%)', bmsHigh: '8(26.67%)', total: '19(21.11%)' },
            { term: 'Dizziness', placebo: '4(13.33%)', bmsLow: '4(13.33%)', bmsHigh: '5(16.67%)', total: '13(14.44%)' },
            { term: 'Somnolence', placebo: '2(6.67%)', bmsLow: '3(10.00%)', bmsHigh: '4(13.33%)', total: '9(10.00%)' },
            { term: 'Tremor', placebo: '1(3.33%)', bmsLow: '2(6.67%)', bmsHigh: '3(10.00%)', total: '6(6.67%)' },
            { term: 'Paraesthesia', placebo: '0(0.00%)', bmsLow: '1(3.33%)', bmsHigh: '2(6.67%)', total: '3(3.33%)' }
          ]
        },
        {
          section: 'Skin and Subcutaneous Tissue Disorders',
          rows: [
            { term: 'Rash', placebo: '3(10.00%)', bmsLow: '4(13.33%)', bmsHigh: '5(16.67%)', total: '12(13.33%)' },
            { term: 'Pruritus', placebo: '2(6.67%)', bmsLow: '3(10.00%)', bmsHigh: '4(13.33%)', total: '9(10.00%)' },
            { term: 'Urticaria', placebo: '1(3.33%)', bmsLow: '1(3.33%)', bmsHigh: '2(6.67%)', total: '4(4.44%)' },
            { term: 'Erythema', placebo: '0(0.00%)', bmsLow: '1(3.33%)', bmsHigh: '2(6.67%)', total: '3(3.33%)' }
          ]
        },
        {
          section: 'Infections and Infestations',
          rows: [
            { term: 'Nasopharyngitis', placebo: '4(13.33%)', bmsLow: '5(16.67%)', bmsHigh: '6(20.00%)', total: '15(16.67%)' },
            { term: 'Upper Respiratory Tract Infection', placebo: '3(10.00%)', bmsLow: '4(13.33%)', bmsHigh: '5(16.67%)', total: '12(13.33%)' },
            { term: 'Urinary Tract Infection', placebo: '2(6.67%)', bmsLow: '2(6.67%)', bmsHigh: '3(10.00%)', total: '7(7.78%)' },
            { term: 'Bronchitis', placebo: '1(3.33%)', bmsLow: '2(6.67%)', bmsHigh: '2(6.67%)', total: '5(5.56%)' }
          ]
        },
        {
          section: 'Musculoskeletal and Connective Tissue Disorders',
          rows: [
            { term: 'Arthralgia', placebo: '3(10.00%)', bmsLow: '4(13.33%)', bmsHigh: '5(16.67%)', total: '12(13.33%)' },
            { term: 'Back Pain', placebo: '2(6.67%)', bmsLow: '3(10.00%)', bmsHigh: '3(10.00%)', total: '8(8.89%)' },
            { term: 'Myalgia', placebo: '1(3.33%)', bmsLow: '2(6.67%)', bmsHigh: '3(10.00%)', total: '6(6.67%)' },
            { term: 'Pain in Extremity', placebo: '1(3.33%)', bmsLow: '1(3.33%)', bmsHigh: '2(6.67%)', total: '4(4.44%)' }
          ]
        }
      ],

      // Listing summary row
      listSummary: { label: 'Number of Subjects with any TEAE', group: 'All', subjects: '74(82.22%)', events: '—', severity: '—' },

      // Listing data sections
      listData: [
        {
          section: 'Gastrointestinal Disorders',
          rows: [
            {
              term: 'Nausea',
              groups: [
                { group: 'Placebo', subjects: '3(10.00%)', events: '3', severity: 'Mild (2), Moderate (1)' },
                { group: 'BMS-Low', subjects: '4(13.33%)', events: '5', severity: 'Mild (3), Moderate (2)' },
                { group: 'BMS-High', subjects: '7(23.33%)', events: '9', severity: 'Mild (4), Moderate (3), Severe (2)' }
              ],
              total: { subjects: '14(15.56%)', events: '17' }
            },
            {
              term: 'Vomiting',
              groups: [
                { group: 'Placebo', subjects: '2(6.67%)', events: '2', severity: 'Mild (2)' },
                { group: 'BMS-Low', subjects: '3(10.00%)', events: '3', severity: 'Mild (2), Moderate (1)' },
                { group: 'BMS-High', subjects: '5(16.67%)', events: '6', severity: 'Mild (3), Moderate (2), Severe (1)' }
              ],
              total: { subjects: '10(11.11%)', events: '11' }
            },
            {
              term: 'Diarrhoea',
              groups: [
                { group: 'Placebo', subjects: '4(13.33%)', events: '4', severity: 'Mild (3), Moderate (1)' },
                { group: 'BMS-Low', subjects: '5(16.67%)', events: '4', severity: 'Mild (2), Moderate (2)' },
                { group: 'BMS-High', subjects: '6(20.00%)', events: '6', severity: 'Mild (3), Moderate (2), Severe (1)' }
              ],
              total: { subjects: '15(16.67%)', events: '14' }
            },
            {
              term: 'Abdominal Pain',
              groups: [
                { group: 'Placebo', subjects: '2(6.67%)', events: '2', severity: 'Mild (2)' },
                { group: 'BMS-Low', subjects: '2(6.67%)', events: '2', severity: 'Mild (1), Moderate (1)' },
                { group: 'BMS-High', subjects: '3(10.00%)', events: '3', severity: 'Mild (2), Moderate (1)' }
              ],
              total: { subjects: '7(7.78%)', events: '7' }
            }
          ]
        },
        {
          section: 'Nervous System Disorders',
          rows: [
            {
              term: 'Headache',
              groups: [
                { group: 'Placebo', subjects: '5(16.67%)', events: '5', severity: 'Mild (4), Moderate (1)' },
                { group: 'BMS-Low', subjects: '6(20.00%)', events: '7', severity: 'Mild (4), Moderate (3)' },
                { group: 'BMS-High', subjects: '8(26.67%)', events: '10', severity: 'Mild (5), Moderate (3), Severe (2)' }
              ],
              total: { subjects: '19(21.11%)', events: '22' }
            },
            {
              term: 'Dizziness',
              groups: [
                { group: 'Placebo', subjects: '4(13.33%)', events: '4', severity: 'Mild (3), Moderate (1)' },
                { group: 'BMS-Low', subjects: '4(13.33%)', events: '5', severity: 'Mild (3), Moderate (2)' },
                { group: 'BMS-High', subjects: '5(16.67%)', events: '6', severity: 'Mild (3), Moderate (2), Severe (1)' }
              ],
              total: { subjects: '13(14.44%)', events: '15' }
            }
          ]
        },
        {
          section: 'Skin and Subcutaneous Tissue Disorders',
          rows: [
            {
              term: 'Rash',
              groups: [
                { group: 'Placebo', subjects: '3(10.00%)', events: '3', severity: 'Mild (2), Moderate (1)' },
                { group: 'BMS-Low', subjects: '4(13.33%)', events: '4', severity: 'Mild (3), Moderate (1)' },
                { group: 'BMS-High', subjects: '5(16.67%)', events: '5', severity: 'Mild (3), Moderate (2)' }
              ],
              total: { subjects: '12(13.33%)', events: '12' }
            }
          ]
        },
        {
          section: 'Infections and Infestations',
          rows: [
            {
              term: 'Nasopharyngitis',
              groups: [
                { group: 'Placebo', subjects: '4(13.33%)', events: '4', severity: 'Mild (3), Moderate (1)' },
                { group: 'BMS-Low', subjects: '5(16.67%)', events: '5', severity: 'Mild (4), Moderate (1)' },
                { group: 'BMS-High', subjects: '6(20.00%)', events: '7', severity: 'Mild (4), Moderate (2), Severe (1)' }
              ],
              total: { subjects: '15(16.67%)', events: '16' }
            }
          ]
        },
        {
          section: 'Musculoskeletal and Connective Tissue Disorders',
          rows: [
            {
              term: 'Arthralgia',
              groups: [
                { group: 'Placebo', subjects: '3(10.00%)', events: '3', severity: 'Mild (2), Moderate (1)' },
                { group: 'BMS-Low', subjects: '4(13.33%)', events: '4', severity: 'Mild (3), Moderate (1)' },
                { group: 'BMS-High', subjects: '5(16.67%)', events: '5', severity: 'Mild (3), Moderate (2)' }
              ],
              total: { subjects: '12(13.33%)', events: '12' }
            },
            {
              term: 'Back Pain',
              groups: [
                { group: 'Placebo', subjects: '2(6.67%)', events: '2', severity: 'Mild (2)' },
                { group: 'BMS-Low', subjects: '3(10.00%)', events: '3', severity: 'Mild (2), Moderate (1)' },
                { group: 'BMS-High', subjects: '3(10.00%)', events: '3', severity: 'Mild (2), Moderate (1)' }
              ],
              total: { subjects: '8(8.89%)', events: '8' }
            }
          ]
        }
      ],
    };
  },

  watch: {
    editingId(newVal) {
      if (newVal) this.fetchShell(newVal);
    },
  },

  async created() {
    await this.fetchTokenOptions();
    if (this.editingId) {
      await this.fetchShell(this.editingId);
    }
  },

  computed: {
    tableHeaders() {
      // First column: Group By field
      const firstColLabel = this.shell?.GroupBy || 'Body System / Preferred Term';
      const headers = [{ label: firstColLabel, align: 'left' }];

      headers.push(
        { label: 'Placebo', sub: '(N=30)', align: 'center' },
        { label: 'BMS-Low', sub: '(N=30)', align: 'center' },
        { label: 'BMS-High', sub: '(N=30)', align: 'center' },
        { label: 'Total', sub: '(N=90)', align: 'center' }
      );

      return headers;
    },
    computedTableData() {
      const columnFieldNames = this.shell?.ColumnFilters || [];
      if (!columnFieldNames || columnFieldNames.length === 0) {
        return this.tableData;
      }

      const data = [];
      columnFieldNames.forEach(filter => {
        let rows = [];
        if (filter === 'AGE') {
          rows = [
            { term: '19', placebo: '1(3.33%)', bmsLow: '1(3.33%)', bmsHigh: '1(3.33%)', total: '3(3.33%)' },
            { term: '23', placebo: '1(3.33%)', bmsLow: '1(3.33%)', bmsHigh: '1(3.33%)', total: '3(3.33%)' },
            { term: '35', placebo: '2(6.67%)', bmsLow: '2(6.67%)', bmsHigh: '2(6.67%)', total: '6(6.67%)' },
            { term: '43', placebo: '5(16.67%)', bmsLow: '5(16.67%)', bmsHigh: '5(16.67%)', total: '15(16.67%)' },
            { term: '44', placebo: '2(6.67%)', bmsLow: '2(6.67%)', bmsHigh: '2(6.67%)', total: '6(6.67%)' },
            { term: '45', placebo: '2(6.67%)', bmsLow: '2(6.67%)', bmsHigh: '2(6.67%)', total: '6(6.67%)' },
            { term: '48', placebo: '6(20.00%)', bmsLow: '6(20.00%)', bmsHigh: '6(20.00%)', total: '18(20.00%)' },
            { term: '55', placebo: '7(23.33%)', bmsLow: '7(23.33%)', bmsHigh: '7(23.33%)', total: '21(23.33%)' },
            { term: '65', placebo: '4(13.33%)', bmsLow: '4(13.33%)', bmsHigh: '4(13.33%)', total: '12(13.33%)' }
          ];
        } else if (filter === 'AGEGR1' || filter === 'AGEGR1N') {
          rows = [
            { term: '>60', placebo: '4(13.33%)', bmsLow: '4(13.33%)', bmsHigh: '4(13.33%)', total: '12(13.33%)' },
            { term: '18-30', placebo: '2(6.67%)', bmsLow: '2(6.67%)', bmsHigh: '2(6.67%)', total: '6(6.67%)' },
            { term: '31-45', placebo: '11(36.67%)', bmsLow: '11(36.67%)', bmsHigh: '11(36.67%)', total: '33(36.67%)' },
            { term: '46-60', placebo: '13(43.33%)', bmsLow: '13(43.33%)', bmsHigh: '13(43.33%)', total: '39(43.33%)' }
          ];
        } else if (filter === 'SEX') {
          rows = [
            { term: 'Female', placebo: '15(50.00%)', bmsLow: '16(53.33%)', bmsHigh: '17(56.67%)', total: '48(53.33%)' },
            { term: 'Male', placebo: '15(50.00%)', bmsLow: '14(46.67%)', bmsHigh: '13(43.33%)', total: '42(46.67%)' }
          ];
        } else if (filter === 'RACE') {
          rows = [
            { term: 'White', placebo: '20(66.67%)', bmsLow: '20(66.67%)', bmsHigh: '20(66.67%)', total: '60(66.67%)' },
            { term: 'Black', placebo: '7(23.33%)', bmsLow: '7(23.33%)', bmsHigh: '6(20.00%)', total: '20(22.22%)' },
            { term: 'Asian', placebo: '3(10.00%)', bmsLow: '3(10.00%)', bmsHigh: '4(13.33%)', total: '10(11.11%)' }
          ];
        } else if (filter === 'AESEV') {
          rows = [
            { term: 'Mild', placebo: '12(40.00%)', bmsLow: '11(36.67%)', bmsHigh: '12(40.00%)', total: '35(38.89%)' },
            { term: 'Moderate', placebo: '13(43.33%)', bmsLow: '14(46.67%)', bmsHigh: '13(43.33%)', total: '40(44.44%)' },
            { term: 'Severe', placebo: '5(16.67%)', bmsLow: '5(16.67%)', bmsHigh: '5(16.67%)', total: '15(16.67%)' }
          ];
        } else {
          rows = [
            { term: 'Category A', placebo: '10(33.33%)', bmsLow: '12(40.00%)', bmsHigh: '15(50.00%)', total: '37(41.11%)' },
            { term: 'Category B', placebo: '20(66.67%)', bmsLow: '18(60.00%)', bmsHigh: '15(50.00%)', total: '53(58.89%)' }
          ];
        }
        data.push({ section: filter, rows });
      });
      return data;
    },
    listingHeaders() {
      const columnFieldNames = this.shell?.ColumnFilters || [];
      const headers = [{ label: 'Body System / Preferred Term', class: 'col-term' }];
      if (!columnFieldNames || columnFieldNames.length === 0) {
        headers.push(
          { label: 'Treatment Group', class: 'col-group' },
          { label: 'Subjects n (%)', class: 'col-subjects' },
          { label: 'Events n', class: 'col-events' },
          { label: 'Severity', class: 'col-severity' }
        );
      } else {
        columnFieldNames.forEach((filter, index) => {
          let cls = 'col-group';
          if (index === columnFieldNames.length - 1) {
            cls = 'col-severity';
          }
          headers.push({ label: filter, class: cls });
        });
      }
      return headers;
    },
    headerRows() {
      return this.shell?.Header?.rows || [];
    },
    footerRows() {
      return this.shell?.Footer?.rows || [];
    },
    titleText() {
      const lines = this.shell?.Title?.lines || [];
      return lines.map(line => this.getTokenLabel(line)).join(", ");
    },
    previewImage() {
      const images = {
        figure:  require("../../assets/img/shellchart.png"),
        table:   require("../../assets/img/shelltable.png"),
        listing: require("../../assets/img/shelllist.png"),
      };
      return images[this.selectoption] || require("../../assets/img/shellchart.png");
    }
  },

  methods: {
    getCellValue(row, headerLabel) {
      if (!row) return '';
      const label = String(headerLabel).toLowerCase().replace(/\s/g, '');
      
      if (label === 'placebo' || label === 'female' || label === 'white' || label === 'mild' || label === 'age') {
        return row.placebo || '';
      }
      if (label === 'bms-low' || label === 'male' || label === 'black' || label === 'moderate' || label === '<65years' || label === 'agegr1' || label === 'agegr1n') {
        return row.bmsLow || '';
      }
      if (label === 'bms-high' || label === 'asian' || label === 'severe' || label === '>=65years') {
        return row.bmsHigh || '';
      }
      if (label === 'total') {
        return row.total || '';
      }
      
      return row.placebo || '0(0.00%)';
    },
    // Returns readable label e.g. "{{Organisation}}" → "Organisation"
    getTokenLabel(value) {
      if (!value) return '';
      const match = this.tokenOptions.find(opt => opt.value === value);
      return match ? match.label : value.replace(/{{|}}/g, '').trim();;
    },

    async fetchTokenOptions() {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/stats-python/shellconfig/tokens`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.tokenOptions = res.data.tokens || [];
      } catch (err) {
        console.error("[ShellPreview] Failed to fetch token options:", err);
        this.tokenOptions = [];
      }
    },

    async fetchShell(id) {
      const idtoken = store.getters.getIdToken;
      this.loading = true;
      this.shell = null;
      try {
        const res = await axios.get(
          `${this.baseurl}/stats-python/shellconfig/${id}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.shell = res.data.data || res.data;
      } catch (err) {
        console.error("[ShellPreview] Failed to fetch shell:", err);
        alert("Failed to load shell preview.");
      } finally {
        this.loading = false;
      }
    },

    closeModal() {
      this.$emit("closeModal");
    },
  },
};